"use strict";
var __makeTemplateObject = (this && this.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var react_1 = __importDefault(require("react"));
var styled_components_1 = __importDefault(require("styled-components"));
var Blog32 = function (props) { return (react_1.default.createElement("svg", __assign({ viewBox: "0 0 32 32", xmlns: "http://www.w3.org/2000/svg", xmlnsXlink: "http://www.w3.org/1999/xlink" }, props),
    react_1.default.createElement("path", { d: "M12.472 17.695h7.397c1.047 0 1.894.851 1.894 1.9 0 1.05-.847 1.901-1.894 1.901h-7.397a1.898 1.898 0 01-1.895-1.9c0-1.05.848-1.9 1.895-1.9zm0 1a.897.897 0 00-.895.9c0 .498.401.901.895.901h7.397a.897.897 0 00.894-.9c0-.498-.4-.9-.894-.9h-7.397zm.113-8.572h3.927c1.119 0 2.008.821 2.008 1.927a2.012 2.012 0 01-2.008 2.015h-3.927a2.012 2.012 0 01-2.008-2.015c0-1.106.89-1.927 2.008-1.927zm0 1c-.583 0-1.008.392-1.008.927 0 .56.453 1.015 1.008 1.015h3.927c.556 0 1.008-.454 1.008-1.015 0-.535-.425-.927-1.008-.927h-3.927zm14.365 9.023a172.581 172.581 0 00.048-2.932c.008-1.267-.01-2.232-.055-2.759-.065-.739-.902-1.241-1.823-1.321a8.048 8.048 0 00-.578-.01 32.89 32.89 0 00-.719.011.5.5 0 01-.514-.5v-1.01c0-3.52-3-6.625-6.438-6.625h-4.587C8.877 5 6 8.072 6 11.625v8.039c0 3.486 2.814 6.313 6.285 6.313l9.342.023c.698.01 1.694-.168 2.667-.71 1.529-.85 2.498-2.375 2.647-4.808l.01-.336zm-2.414-8.023c.3-.002.527.002.67.014 1.346.118 2.615.878 2.733 2.23.05.569.067 1.555.06 2.853a145.032 145.032 0 01-.059 3.299c-.169 2.795-1.332 4.629-3.16 5.645-1.151.641-2.31.848-3.165.836l-9.331-.023C8.26 26.977 5 23.702 5 19.664v-8.04C5 7.535 8.31 4 12.284 4h4.587c3.998 0 7.438 3.56 7.438 7.625v.5l.227-.002z", className: "blog-32_svg__path-1" }))); };
var StyledBlog32 = styled_components_1.default(Blog32)(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n  width: ", ";\n  height: ", ";\n  color: ", ";\n  vertical-align: middle;\n  fill: ", ";\n\n  ", "\n"], ["\n  width: ", ";\n  height: ", ";\n  color: ", ";\n  vertical-align: middle;\n  fill: ", ";\n\n  ", "\n"])), function (_a) {
    var _b = _a.size, size = _b === void 0 ? '32px' : _b;
    return size;
}, function (_a) {
    var _b = _a.size, size = _b === void 0 ? '32px' : _b;
    return size;
}, function (_a) {
    var color = _a.color, theme = _a.theme;
    return color || theme.base.color.text;
}, function (_a) {
    var color = _a.color, theme = _a.theme;
    return color || theme.base.color.text;
}, function (_a) {
    var stroke = _a.stroke;
    return stroke && "stroke: " + stroke + "; stroke-width: 64;";
});
exports.default = StyledBlog32;
var templateObject_1;
//# sourceMappingURL=Blog32.js.map